"use client";

import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  titleText: string;
  descriptionText: string;
  cancelText: string;
  confirmText: string;
  /** Quando false, exibe apenas o botão de fechar (cancelText), sem botão de confirmar */
  showConfirmButton?: boolean;
  isLoading?: boolean;
  /** Largura mínima do Paper do diálogo (ex.: "500px" ou 560) */
  minWidth?: number | string;
  /** Largura máxima do Paper do diálogo (ex.: "90vw" ou 600) */
  maxWidth?: number | string;
  /** Texto extra exibido abaixo da descrição principal */
  additionalDescriptionText?: string;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  titleText,
  descriptionText,
  cancelText,
  confirmText,
  showConfirmButton = true,
  isLoading = false,
  minWidth,
  maxWidth,
  additionalDescriptionText,
}) => {
  const paperSx =
    minWidth != null || maxWidth != null
      ? { minWidth: minWidth ?? undefined, maxWidth: maxWidth ?? undefined }
      : undefined;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      style={{ padding: 10 }}
      PaperProps={paperSx ? { sx: paperSx } : undefined}
    >
      <DialogTitle>{titleText}</DialogTitle>
      <DialogContent>
        <MDTypography variant="body2" color="text" sx={{ whiteSpace: "pre-line" }}>
          {descriptionText}
        </MDTypography>
        {additionalDescriptionText && (
          <MDTypography variant="body2" color="text" sx={{ mt: 1.5, display: "block", whiteSpace: "pre-line" }}>
            {additionalDescriptionText}
          </MDTypography>
        )}
      </DialogContent>
      <DialogActions style={{ padding: 10 }}>
        <MDButton variant="outlined" color="dark" fullWidth onClick={onClose} disabled={isLoading}>
          {cancelText}
        </MDButton>
        {showConfirmButton && (
          <MDButton
            variant="gradient"
            color="dark"
            fullWidth
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {confirmText}
          </MDButton>
        )}
      </DialogActions>
    </Dialog>
  );
};
